async function tryRievNow() {
  document.getElementById("pdpProductForm").scrollIntoView({ behavior: "smooth" });
  // openCart();
  // const variantId = parseInt(document.querySelector("#pdpProductForm").getAttribute("data-selected-variant"))
  //   , planId = parseInt(document.querySelector("#pdpProductForm").getAttribute("data-selected-plan"))
  //   , product = {
  //     items: [{
  //         quantity: 1,
  //         id: variantId
  //     }]
  // };
  // planId && (product.items[0].selling_plan = planId);
  // await addProduct(product),
  // // window.location.href = "/cart";
  // await openCart();
};

window.addEventListener('scroll', function() {
  const button = document.getElementById('productATC_sticky');
  const targetEle = document.getElementById('productInner');
  const rect = targetEle.getBoundingClientRect();
  const inView = rect.top < window.innerHeight && rect.bottom > 0;

  if (inView) {
    button.style.display = 'none';
  } else {
    button.style.display = 'block';
  }
  
});

let productImages = new Swiper("#productSwiper",{
    slidesPerView: 1,
    breakpoints: {
        800: {
            spaceBetween: 20,
            pagination: !1
        }
    },
    navigation: {
        prevEl: "#productSwiperPrev",
        nextEl: "#productSwiperNext"
    },
    spaceBetween: 40
});
document.querySelectorAll(".productThumbnail").forEach(function(element) {
    element.addEventListener("click", function() {
        let index = getElIndex(this);
        productImages.slideTo(index)
    })
}),
document.querySelectorAll(".productFaqTop").forEach(el => {
    let parent = el.closest(".productFaq");
    el.addEventListener("click", function() {
        this.classList.toggle("active"),
        parent.querySelector(".productFaqBottom").classList.toggle("active")
    })
}
);
const productFormObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.type === "attributes") {
            const parsedFinalPrice = parseFloat(mutation.target.getAttribute("data-final-price").replace(currency, ""));
            document.querySelector(".productATCPrice").innerText = ` ${price(parsedFinalPrice)}`
        }
    })
}
);
productFormObserver.observe(document.querySelector("#pdpProductForm"), {
    attributes: !0
}),
document.querySelector("#productATC").addEventListener("click", async function() {
    this.classList.add("loading");
    const variantId = parseInt(document.querySelector("#pdpProductForm").getAttribute("data-selected-variant"))
      , planId = parseInt(document.querySelector("#pdpProductForm").getAttribute("data-selected-plan"))
      , product = {
        items: [{
            quantity: 1,
            id: variantId
        }]
    };
    planId && (product.items[0].selling_plan = planId);
    await addProduct(product),
    // window.location.href = "/cart";
    await openCart();
    this.classList.remove("loading")
}),
document.querySelectorAll('.button[href="#"]').forEach(button => button.addEventListener("click", function(event) {
    event.preventDefault();
    const buyBox = document.querySelector(".checkInner");
    buyBox ? buyBox.scrollIntoView({
        top: 0,
        behavior: "smooth"
    }) : window.scrollTo({
        top: 0,
        behavior: "smooth"
    })
}));